(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['./NavView', 'app/ereg/nav/EregNavView'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    module.exports = factory(require('./NavView'), require('./../ereg/nav/EregNavView'));
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (NavView, EregNavView) {
  'use strict';

  /**
   * Static nav views for patient and staff.
   *
   * @class eregNavViews
   * @static
   */
   return {
    /**
     * @property patient {NavView} static nav view tailored to the portal experience
     */
    patient: new NavView(),

    /**
     * @property eregPatient {EregNavView} static nav view tailored to the patient experience in ereg.
     */
    eregPatient: new EregNavView({
      className: EregNavView.prototype.className + ' topnav--ereg-nav-patient',
      isPatient: true
    }),

    /**
     * @property eregStaff {EregNavView} static nav view tailored to the staff experience in ereg.
     */
    eregStaff: new EregNavView({
      className: EregNavView.prototype.className + ' topnav--ereg-nav-staff',
      isPatient: false
    })
  };
}));
